import useFieldHelper from './fieldHelper';
import TextField from './text/TextField';
import { FieldProps } from './types';
/* istanbul ignore file */
import { BOOLEAN_OPTIONS } from 'framework/form';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const BooleanOptionField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);

  const fieldValue = getValue();

  const optionValue = BOOLEAN_OPTIONS.find(option => option.value === fieldValue);

  const displayedValue = optionValue ? optionValue.label : EMPTY_VALUE_INDICATOR;

  return <TextField value={displayedValue} {...props} />;
};

export default BooleanOptionField;
